import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", null, this.attr(`parts`).map(
    (part) => typeof part === `object` ? part.class ? /* @__PURE__ */ jsx("span", {
      class: { [part.class]: true }
    }, part.text) : part.text : part
  ));
}
